// Phase 1 — Super-Admin Health Dashboard
// Aggregates BackupHealthCard + SystemHealthCard for owner-level visibility.
import BackupHealthCard from "@/components/BackupHealthCard";
import SystemHealthCard from "@/components/SystemHealthCard";
import ModuleHint from "@/components/ModuleHint";
import { Activity } from "lucide-react";

export default function SuperAdminHealth() {
  return (
    <div className="p-6 md:p-8 max-w-7xl mx-auto" data-testid="super-admin-health-page">
      <div className="flex items-center gap-3 mb-2">
        <Activity className="w-6 h-6 text-blue-400" />
        <h1 className="font-display text-2xl font-semibold text-zinc-100">System &amp; Backup-Health</h1>
        <span className="ml-2 px-2 py-0.5 rounded bg-amber-500/15 border border-amber-500/40 text-amber-300 text-[10px] font-bold tracking-wider uppercase">
          Super-Admin
        </span>
      </div>
      <p className="text-sm text-zinc-500 mb-6">
        Operative Plattform-Übersicht. Backups, Mandanten, User-Aktivität, Audit-Events und Background-Jobs auf einen Blick.
      </p>

      <ModuleHint moduleKey="security" defaultOpen={false} />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        <SystemHealthCard />
        <BackupHealthCard />
      </div>
    </div>
  );
}
